import React, { useState } from 'react';
import '../style/progressiveImage.scss';

/**
 * Renders an image with optional WebP/AVIF via <picture>, and placeholder + fade-in.
 * Use optimized URLs from the backend when present; fall back to main src.
 * All optimized URL props are optional — when missing, behaves like a single <img>.
 */
export const OptimizedImage = ({
  src,
  srcSetWebp,
  srcSetAvif,
  alt = '',
  className = '',
  style = {},
  imgStyle = {},
  placeholderClassName = '',
  aspectRatio,
  loading = 'lazy',
  ...imgProps
}) => {
  const [loaded, setLoaded] = useState(false);
  const fallbackSrc = src || '';

  const containerStyle = {
    ...style,
    ...(aspectRatio ? { aspectRatio } : {}),
  };

  const imgEl = (
    <img
      src={fallbackSrc}
      alt={alt}
      className={`progressive-image-img ${loaded ? 'progressive-image-loaded' : ''} ${className}`.trim()}
      style={imgStyle}
      loading={loading}
      onLoad={() => setLoaded(true)}
      {...imgProps}
    />
  );

  const usePicture = (srcSetWebp || srcSetAvif) && fallbackSrc;

  return (
    <span className={`progressive-image-wrap ${placeholderClassName}`.trim()} style={containerStyle}>
      {!loaded && <span className="progressive-image-placeholder" aria-hidden="true" />}
      {usePicture ? (
        <picture>
          {srcSetAvif && <source type="image/avif" srcSet={srcSetAvif} />}
          {srcSetWebp && <source type="image/webp" srcSet={srcSetWebp} />}
          {imgEl}
        </picture>
      ) : (
        imgEl
      )}
    </span>
  );
};
